module.exports = __webpack_public_path__ + "static/media/featured.companies.476c88d4.png";